import { IBorderRadius, IBorderWidth } from "../types";

export const borderWidth: IBorderWidth = {
    "border-width-regular": "1",
    "border-width-medium": "2",
    "border-width-large": "4",
    "border-width-x-large": "8"
};

export const borderRadius: IBorderRadius = {
    "border-radius-none": "0",
    "border-radius-4x-small": "0.125",
    "border-radius-3x-small": "0.25",
    "border-radius-xx-small": "0.375",
    "border-radius-x-small": "0.5",
    "border-radius-small": "0.75",
    "border-radius-regular": "1",
    "border-radius-medium": "1.25",
    "border-radius-large": "1.5",
    "border-radius-x-large": "1.75",
    "border-radius-xx-large": "2",
    "border-radius-3x-large": "2.25",
    "border-radius-4x-large": "2.5",
    "border-radius-full": "9999"
};
